<template>
  <v-hover >
    <div
      slot-scope="{ hover }"
      :class="`elevation-${hover ? 14 : 2} mx-auto border-card`"
      :style="validateSelect"
      @click.prevent="selectCardPoint()"
    >
      <v-card-text
        style="font-size: 15px; color: #79828c;"
      >
        <div class="font-weight-bold text-uppercase" style="color: #009640 !important; font-size: 15px; display: flex !important">
          <div style="width: 100%" class="pr-3">
            {{point.NOMBRE_DIVISION}}
          </div>
          <div style="min-width: 80px">
            <v-btn
              @click="selectMode('DRIVING')"
              elevation="0"
              class="px-0 min-content"
            >
              <v-img v-if="getTravelMode == 'DRIVING'" :width="sizeIcon" src="../assets/icons/car_active.svg"></v-img>
              <v-img v-else :width="sizeIcon" src="../assets/icons/car.svg"></v-img>
            </v-btn>

            <v-btn
              @click="selectMode('TRANSIT')"
              elevation="0"
              class="px-0 ml-1 min-content"
            >
              <v-img v-if="getTravelMode == 'TRANSIT'" :width="sizeIcon" src="../assets/icons/bus_active.svg"></v-img>
              <v-img v-else :width="sizeIcon" src="../assets/icons/bus.svg"></v-img>
            </v-btn>

            <v-btn
              @click="selectMode('WALKING')"
              elevation="0"
              class="pa-0 ml-1 min-content"
            >
              <v-img v-if="getTravelMode == 'WALKING'" :width="sizeIcon" src="../assets/icons/walk_active.svg"></v-img>
              <v-img v-else :width="sizeIcon" src="../assets/icons/walk.svg"></v-img>
            </v-btn>
          </div>
        </div>

        <v-divider style="background: ##ff0000 !important" class="my-2"></v-divider>
        <div>
          <b :style="validateTextColor">Dirección: </b> <span>{{point.DIRECCION_DIVISION}}</span>
        </div>
        <div>
           <b :style="validateTextColor">Código postal: </b> <span>{{point.CODIGO_POSTAL}}</span>
        </div>
        <div>
           <b :style="validateTextColor">Código postal ampliado: </b> <span>{{point.CODIGO_POSTAL_AMPLIADO}}</span>
        </div>
        <div>
          <b :style="validateTextColor">Ciudad: </b> <span>{{point.NOMBRE_CIUDAD}}</span>
        </div>
        <div>
          <b :style="validateTextColor">Departamento: </b> <span>{{point.NOMBRE_DEPARTAMENTO}}</span>
        </div>
        <div>
          <b :style="validateTextColor">Teléfono: </b> <span>{{point.NUMEROS_TELEFONO}}</span>
        </div>
        <div>
          <b :style="validateTextColor">Horario: </b> <span v-html="point.HORARIOS_ATENCION"></span>
        </div>
        <div class="subheading">
          <b :style="validateTextColor">Distancia de ruta en carro: </b> <span>{{point.DISTANCIA_DEL_CLIENTE}} m </span>
        </div>
      </v-card-text>

      <div v-if="point.select" class="pb-1">

        <div class="btn-display mr-4">
          <v-btn
            @click="closeCardsAct()"
            color="#009640"
            dark
            small
            class="mb-3 ml-3"
            style="border-radius: 6px"
          >
            <v-icon left small>
              mdi-close
            </v-icon>
            Cerrar</v-btn>

          <v-btn
            @click.prevent="print()"
            color="#009640"
            dark
            class="mb-3 ml-3"
            small
            style="border-radius: 6px"
          >
            <v-img class="mr-1" style="max-width: 19px !important; height: 18px;" src="../assets/icons/printer.svg"></v-img>
            Imprimir</v-btn>
        </div>

        <Indications id="indications-print"/>       
      </div>
    </div>
  </v-hover>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import Indications from './Indications';
  export default {
    name: "CardPoint", 
    /* Componente Encargado de la tarjeta que representa un punto de atención  */
    props:{
      point: Object,
      index: Number
    },
    components: {
      Indications
    },
    data: () => ({
      travelMode: 'DRIVING',
      clickCard: null,
      validateBtn: true,
      sizeIcon: 24
    }),
    computed: {
      ...mapGetters(['getDirections', 'getTravelMode']),
      /* 
        Función encargada cambiar el fondo de la tarjeta dependiendo de su seleccion
      */
      validateSelect() {
        return this.point.select ? 
          'background-color: #fff !important;' : 
          'background-color: #e6e6e6';
      },
      validateTextColor() {
        return 'color: #310605;'
        /* this.point.select ? '' :
          'color: #3da54f !important;'; */
      }
    },
    methods: {
      ...mapActions(['selectCard', 'addMarketSelect', 'closeCards', 'addTravelMode']),
      /* 
        Este método invoca la funcionalidad del componente padre "ListPoints" que recibe el index
      */
      selectCardPoint(){
        if(this.validateBtn){
          this.$emit("onSelectMode", this.getTravelMode);
          this.selectCard(this.index);
          const obj = {
            lat: this.point.LATITUDE,
            lng: this.point.LONGITUDE
          }
          this.addMarketSelect(obj);
        }
        this.validateBtn = true;
      },
      selectMode(mode){
        if(mode != this.getTravelMode ){

          this.$emit("onSelectMode", mode);
        }
        this.addTravelMode(mode);
      },
      closeCardsAct(){
        this.validateBtn = false;
        this.closeCards();
      },
      print(){
        this.$emit("onPrint");
      }
    }
  }
</script>

<style>
.v-card--reveal {
  align-items: center;
  top: 0;
  justify-content: center;
  opacity: .5;
  position: absolute;
  width: 100%;
}

.border-card {
  border-radius: 10px;
}

.border-user {
  border-radius: 6px;
  border: 1px solid;
  font-size: 13px;
  font-weight: bold !important;
  line-height: 17px;
  padding: 5px 7px;
  background-color: #f2f2f2;
}

.border-point {
  border-radius: 6px;
  border: 1px solid #009640;
  color: #009640;
  font-size: 13px;
  font-weight: bold !important;
  line-height: 17px;
  padding: 5px 7px;
  background-color: #f2f2f2;
}

.min-content {
  min-width: min-content !important; 
  height: min-content !important;
}

div span {
  font-weight: 400;
}

.theme--light.v-divider {
  border-color: #009640 !important; 
  padding: 2px;
}

.btn-display{
  display: flex;
  justify-content: flex-end;
}

@media (max-width: 380px) {
  .btn-display{
    display: grid;
    align-content: center;
    justify-content: center !important;
  }
}

@media (max-width: 1200px) and (min-width: 768px) {
  .btn-display{
    display: grid;
    align-content: center;
    justify-content: center !important;
  }
}
</style>